var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174 174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.24,148.47H63.76a38.27,38.27,0,0,1-38.23-38.23V63.76A38.27,38.27,0,0,1,63.76,25.53h46.48a38.27,38.27,0,0,1,38.23,38.23v46.48A38.27,38.27,0,0,1,110.24,148.47Zm-46.48-113a28.33,28.33,0,0,0-28.3,28.3v46.48a28.33,28.33,0,0,0,28.3,28.3h46.48a28.33,28.33,0,0,0,28.3-28.3V63.76a28.33,28.33,0,0,0-28.3-28.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87,117.78A30.78,30.78,0,1,1,117.78,87,30.81,30.81,0,0,1,87,117.78Zm0-51.62A20.84,20.84,0,1,0,107.85,87,20.87,20.87,0,0,0,87,66.16Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 53.79,
    r: 7.32
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIns);
export default __webpack_public_path__ + "static/media/ins.e0c48ced.svg";
export { ForwardRef as ReactComponent };